/* Modulo Product Grid — quick-add + wishlist for a static product grid.
   Vanilla, lazy-init, no slider. Cart-add mirrors the featured-products pattern. */
(function () {
  'use strict';
  if (typeof window === 'undefined') return;
  /* Load-once guard: the section emits one <script> per instance, so 2+ grids on a
     page would otherwise register the document listener twice and double-toggle wishlist. */
  if (window.__moduloPgLoaded) return;
  window.__moduloPgLoaded = true;

  /* ─── Wishlist (localStorage, no backend) ─── */
  function wishlistRead(key) {
    try { var raw = localStorage.getItem(key); return raw ? JSON.parse(raw) : []; }
    catch (e) { return []; }
  }
  function wishlistWrite(key, list) {
    try { localStorage.setItem(key, JSON.stringify(list)); } catch (e) {}
  }
  function wishlistKey(root) {
    return root.getAttribute('data-modulo-pg-wishlist-key') || 'modulo_wishlist';
  }
  function wishlistHydrate(root) {
    var key = wishlistKey(root);
    var saved = wishlistRead(key);
    if (!saved.length) return;
    var buttons = root.querySelectorAll('[data-modulo-pg-wishlist]');
    for (var i = 0; i < buttons.length; i++) {
      var h = buttons[i].getAttribute('data-product-handle');
      if (saved.indexOf(h) !== -1) {
        buttons[i].classList.add('is-active');
        buttons[i].setAttribute('aria-pressed', 'true');
      }
    }
  }
  function wishlistToggle(btn, root) {
    var key = wishlistKey(root);
    var h = btn.getAttribute('data-product-handle');
    var list = wishlistRead(key);
    var idx = list.indexOf(h);
    if (idx === -1) {
      list.push(h);
      btn.classList.add('is-active');
      btn.setAttribute('aria-pressed', 'true');
    } else {
      list.splice(idx, 1);
      btn.classList.remove('is-active');
      btn.setAttribute('aria-pressed', 'false');
    }
    wishlistWrite(key, list);
    document.dispatchEvent(new CustomEvent('modulo:wishlist:changed', {
      detail: { handle: h, active: idx === -1, key: key }
    }));
  }
  document.addEventListener('modulo:wishlist:changed', function (e) {
    var d = e.detail;
    var selector = '[data-modulo-pg-wishlist][data-product-handle="' + d.handle + '"]';
    var buttons = document.querySelectorAll(selector);
    for (var i = 0; i < buttons.length; i++) {
      var section = buttons[i].closest('[data-modulo-pg-wishlist-key]');
      if (!section || section.getAttribute('data-modulo-pg-wishlist-key') !== d.key) continue;
      if (d.active) {
        buttons[i].classList.add('is-active');
        buttons[i].setAttribute('aria-pressed', 'true');
      } else {
        buttons[i].classList.remove('is-active');
        buttons[i].setAttribute('aria-pressed', 'false');
      }
    }
  });

  /* ─── Cart add ─── */
  function findCartDrawer() {
    return document.querySelector('cart-drawer, cart-drawer-component, [is="cart-drawer"], [data-cart-drawer]');
  }
  function openCartDrawer() {
    var drawer = findCartDrawer();
    if (!drawer) return;
    if (typeof drawer.open === 'function') drawer.open();
    else if (typeof drawer.show === 'function') drawer.show();
    else {
      var trigger = document.querySelector('[aria-controls*="cart"]');
      if (trigger) trigger.click();
    }
  }
  function quickAdd(button) {
    if (button.dataset.adding === '1') return;
    button.dataset.adding = '1';
    var variantId = button.getAttribute('data-variant-id');
    var labelEl = button.querySelector('.modulo-pg__qa-label');
    var originalLabel = labelEl ? labelEl.textContent : '';
    var addedLabel = button.getAttribute('data-added-label') || 'Added';

    fetch(window.Shopify && window.Shopify.routes && window.Shopify.routes.root
      ? window.Shopify.routes.root + 'cart/add.js' : '/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
    }).then(function (r) {
      if (!r.ok) throw new Error('cart-add-failed');
      return r.json();
    }).then(function () {
      button.classList.add('is-added');
      if (labelEl) labelEl.textContent = addedLabel;
      setTimeout(function () {
        button.classList.remove('is-added');
        if (labelEl) labelEl.textContent = originalLabel;
      }, 1800);
      document.dispatchEvent(new CustomEvent('cart:refresh'));
      document.dispatchEvent(new CustomEvent('cart:updated'));
      openCartDrawer();
    }).catch(function () {
      if (labelEl) {
        labelEl.textContent = 'Error';
        setTimeout(function () { labelEl.textContent = originalLabel; }, 1800);
      }
    }).finally(function () {
      button.dataset.adding = '0';
    });
  }

  /* ─── Init ─── */
  function initSection(root) {
    root.addEventListener('click', function (e) {
      var qaBtn = e.target.closest('[data-modulo-pg-quick-add]');
      if (qaBtn && qaBtn.tagName === 'BUTTON' && !qaBtn.disabled) {
        e.preventDefault();
        e.stopPropagation();
        quickAdd(qaBtn);
        return;
      }
      var wlBtn = e.target.closest('[data-modulo-pg-wishlist]');
      if (wlBtn) {
        e.preventDefault();
        e.stopPropagation();
        wishlistToggle(wlBtn, root);
        return;
      }
    });
    wishlistHydrate(root);
  }

  function bootstrap() {
    if (window.moduloLazyInit) {
      window.moduloLazyInit('[data-modulo-pg]', initSection);
    } else {
      var sections = document.querySelectorAll('[data-modulo-pg]');
      for (var i = 0; i < sections.length; i++) initSection(sections[i]);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootstrap);
  } else {
    bootstrap();
  }
})();
